<template>
    <div class="absolute t-10 r-10 z-50">
        <div v-cloak v-show="!loading">
            <!-- <div v-cloak v-show="!emptyNotifications"> -->
                <notification-item v-for="notification in notifications" :key="notification.id" :notification="notification" />
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        notifications: [],
        loading: false,
        audio: null
    }),

    created() {
        const user = this.user;
        if (!user) {
            return;
        }

        const sound = "/sounds/pop.mp3";
        var audio = new Audio(sound);
        // audio.autoplay = true;
        // audio.muted = true;
        // audio.volume = 0.2;
        // audio.pause();
        audio.load();
        this.audio = audio;

        const userId = user.id;

        Echo.private('users.' + userId)
            .notification((notification) => {
                if (notification.type === 'App\\Notifications\\ProductInStock') {
                    this.addNotification(notification);
                }
            });

        // this.fetchNotifications();
    },

    mounted() {},

    computed: {
        emptyNotifications() {
            return this.notifications.length == 0;
        }
    },

    methods: {
        addNotification(notification) {
            // console.log(notification);
            // console.log(notification.type);
            this.notifications.push(notification);

            try {
                var promise = this.audio.play();

                if (promise !== undefined) {
                    promise
                        .then(_ => {})
                        .catch(error => {});
                }
            } catch (e) {
                // Error: NotAllowedError: play() failed because the user didn't interact with the document first.
                // @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
                // @see https://sites.google.com/a/chromium.org/dev/audio-video/autoplay
                // @see https://github.com/GoogleChromeLabs/airhorn
                // @see https://github.com/apoStyLEE/vueaudioplayer
                // @see https://developers.google.com/web/updates/2017/09/autoplay-policy-changes#webaudio
                // @see https://goo.gl/xX8pDD
                // @see https://developers.google.com/web/updates/2016/03/play-returns-promise
                // @see https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
                // @see https://forum.vuejs.org/t/safari-audio-play-notallowederror-dom-exception-35/25099/5
                // console.error(e);
            }
        },

        fetchNotifications() {
            this.loading = true;

            axios
                .get("/api/notifications")
                .then(response => {
                    this.notifications = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
